'use strict';

var Emitter = require('cjs-emitter'),
    intentLog, systemLog;


if ( DEVELOP ) {
    intentLog = debug('intent');
    systemLog = debug('system');
}

function Intent ( config, callback ) {
    var eventName, state;

    if ( DEVELOP ) {
        state = Intent.prototype.STATE_CREATED;
        Object.defineProperty(this, 'state', {
            set: function (value) {
                switch ( value ) {
                    case Intent.prototype.STATE_CLOSED:
                        intentLog('state change, new state: STATE_CLOSED');
                        break;

                    case Intent.prototype.STATE_CONTEXT_RECEIVED:
                        intentLog('state change, new state: STATE_CONTEXT_RECEIVED');
                        break;

                    case Intent.prototype.STATE_CREATED:
                        intentLog('state change, new state: STATE_CREATED');
                        break;

                    case Intent.prototype.STATE_ERROR_RECEIVED:
                        intentLog('state change, new state: STATE_ERROR_RECEIVED');
                        break;

                    case Intent.prototype.STATE_NOT_RESOLVED:
                        intentLog('state change, new state: STATE_NOT_RESOLVED');
                        break;

                    case Intent.prototype.STATE_PAUSED:
                        intentLog('state change, new state: STATE_PAUSED');
                        break;

                    case Intent.prototype.STATE_RESOLVED:
                        intentLog('state change, new state: STATE_RESOLVED');
                        break;
                }
                state = value;
            },
            get: function () {
                return state;
            }
        });
    } else {
        this.state = Intent.prototype.STATE_CREATED;
    }

    this.action = config.action;

    this.parent = config.parent || null;

    this.mime = config.mime;

    this.data = config.data;

    this.context = config.context;

    this.silent = config.silent;

    this.callback = callback;

    Emitter.call(this, config);

    if ( config.events ) {
        for ( eventName in config.events ) {
            if ( config.events[eventName] ) {
                this.addListener(eventName, config.events[eventName]);
            }
        }
    }
}

// inheritance
Intent.prototype = Object.create(Emitter.prototype);
Intent.prototype.constructor = Intent;

Intent.prototype.STATE_CREATED = 0;
Intent.prototype.STATE_RESOLVED = 1;
Intent.prototype.STATE_NOT_RESOLVED = 2;
Intent.prototype.STATE_CONTEXT_RECEIVED = 3;
Intent.prototype.STATE_ERROR_RECEIVED = 4;
Intent.prototype.STATE_CLOSED = 5;
Intent.prototype.STATE_PAUSED = 6;


Intent.prototype.emit = function ( name, data ) {
    var event = this.events[name],
        index;

    // the event exists and should have some callbacks
    if ( event ) {
        for ( index = 0; index < event.length; index++ ) {
            if ( DEVELOP ) {
                if ( typeof event[index] !== 'function' ) {
                    throw new Error(__filename + ': wrong event callback type');
                }
            }

            // invoke the callback with parameters
            try {
                event[index].call(this, data);
            } catch ( error ) {
                if ( DEVELOP ) {
                    intentLog('error in emit: ' + error);
                }
            }
        }
    }
};

Intent.prototype.close = function ( event ) {
    this.state = Intent.prototype.STATE_CLOSED;

    this.emit('close', event);
};

Intent.prototype.show = function ( pid, config ) {
    var self = this,
        taskManager = require('./task.manager'),
        Core = require('../kernel/core'),
        meta = {
            source: Core.prototype.SOURCES.INTENT,
            data: {
                intent: self,
                config: config
            }
        };

    if ( DEVELOP ) {
        systemLog(taskManager.apps[pid]);
        systemLog('check ' + pid);
        Object.keys(taskManager.apps).forEach(function ( processId ) {
            systemLog('status ' + processId + ': ' + taskManager.apps[processId]);
        });
    }
    if ( taskManager.apps[pid] ) {
        if ( DEVELOP ) {
            systemLog(taskManager.topApp.pid !== pid);
            systemLog(taskManager.topApp.pid);
            systemLog(pid);
            systemLog('meta: ' + meta);
            systemLog('meta source: ' + meta.source);
        }

        if ( taskManager.topApp.pid !== pid ) {
            taskManager.show(taskManager.apps[pid], meta);
        }
    } else {
        if ( DEVELOP ) {
            systemLog(typeof taskManager.topApp);
            systemLog(taskManager.topApp);
        }
        if ( taskManager.topApp ) {
            taskManager.topApp.$iframe.hide();
            taskManager.topApp.core.emit('hide', {
                source: Core.prototype.SOURCES.SYSTEM
            });
        }
        taskManager.show(taskManager.launcher);
        taskManager.launcher.core.emit('focus');
    }
};

Intent.prototype.pause = function () {
    this.savedstate  = this.state;
    this.state = Intent.prototype.STATE_PAUSED;
};

Intent.prototype.resume = function () {
    var self = this;

    setTimeout(function () {
        self.state = Intent.prototype.STATE_CREATED;
        if ( typeof self.continueCallback === 'function' ) {
            self.continueCallback();
        }
    }, 0);
};

module.exports = Intent;
